class ResponsiveTablesLight {
  constructor(config = {}) {
    const {
      tableComponentSelector,
      tableContainerSelector,
      tableSelector
    } = config;

    this.tables = document.querySelectorAll(tableSelector);
    this.tablesArray = Array.prototype.slice.call(this.tables);

    if (this.tables) {
      this.tablesArray.forEach(table => {
        let container = table.closest(tableContainerSelector);
        let component = table.closest(tableComponentSelector);

        this.toggleResponsiveTableClasses(component, container, table);
      });
    }

    this.hasRowSpan();

  }


  toggleResponsiveTableClasses(component, container, table) {
    if(this.hasHorizontalScrollbar(container, table) === true && this.hasRowSpan() === false) {
      component.classList.add('has-shadow', 'responsive-table');
    } else if(this.hasHorizontalScrollbar(container, table) === true && this.hasRowSpan() === true) {
      component.classList.add('responsive-table-alternative');
    } else {
      component.classList.remove('has-shadow', 'responsive-table', 'responsive-table-alternative');
    }

    window.addEventListener('resize', () => {
      if(this.hasHorizontalScrollbar(container, table) === true && this.hasRowSpan() === false) {
        component.classList.add('has-shadow', 'responsive-table');
      } else if(this.hasHorizontalScrollbar(container, table) === true && this.hasRowSpan() === true) {
        component.classList.add('responsive-table-alternative');
      } else {
        component.classList.remove('has-shadow', 'responsive-table', 'responsive-table-alternative');
      }
    });
  }

  hasHorizontalScrollbar(container, table) {
    const containerWidth = container.clientWidth;
    const tableWidth = table.clientWidth;

    return tableWidth > containerWidth;
  }

  hasRowSpan() {
    const tableCells = document.querySelectorAll('.lc-component--table table td[rowspan]');
    const tableCellsArray = Array.prototype.slice.call(tableCells);

    if (tableCellsArray.length > 0) {
      return true;
    } else {
      return false;
    }
  }
}
export default ResponsiveTablesLight;
